export const publicKeyToUint8Array = (publicKeyInput: string): Uint8Array => {
  const cleanedBase64 = publicKeyInput.replace(/\n/g, '').replace(/\r/g, '');
  const base64 = cleanedBase64.replace(/-/g, '+').replace(/_/g, '/');
  const paddedBase64 = base64.padEnd(
    base64.length + ((4 - (base64.length % 4)) % 4),
    '='
  );
  const binaryString =
    typeof window !== 'undefined' ? window.atob(paddedBase64) : paddedBase64;
  const uint8Array = new Uint8Array(binaryString.length);
  for (let i = 0; i < binaryString.length; i++) {
    uint8Array[i] = binaryString.charCodeAt(i);
  }

  return uint8Array;
};
